import biRequest from "./index";
import JSEncrypt from 'jsencrypt'

const publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDHqmOwCkpzUEZTDPD5gl0ROk5qhQXe0b4OI6xJ7CwFt + 6yIzp3azBKBTrVSGuCJcSUC71wV9l3OLu73W1S265N9Mu9UzaZBsHTtOyrA3OB / VseNhe1tuABNFL2NA / 5 / qao08GC6HC6Nw2UeDEz8GlG5b4ok94Q9XBMdQpyxM8zCQIDAQAB";
const encrypt = (data) => {
	const encrypted = new JSEncrypt();
	encrypted.setPublicKey(publicKey);
	const strData = String(data)
	return encrypted.encrypt(strData)
}

// const decrypt = (data) => {
// 	const encrypted = new JSEncrypt();
// 	encrypted.setPrivateKey(privateKey);
// 	return encrypted.decrypt(data)
// }

const proxyHead = ''

// /**
//  *	@description 发送手机验证码
//  * 	@returns
//  */
// export function getPhoneCode(params) {
// 	const url = proxyHead +  "/Home/SendMessage"
// 	return biRequest({ url, method: 'get', params});
// }

/**
 *	@description 发送手机验证码
 * 	@returns
 */
export function getPhoneCode(requestData) {
	const url = proxyHead +  "/api/popularize/public/register/sendMessage"
	const {
		phone,
		...restData
	} = requestData


	const needEncrypt = {
		phone: requestData.phone,
		cdate: Date.now(),
		randomX: requestData.randomX
	}
	
	const passData = encrypt(JSON.stringify(needEncrypt))
	const imageCaptchaTrackDtoData = {
		cdate: Date.now(),
		targetX: requestData.targetX,
		...restData,
	}
	const submitData = {
		randstr: passData,
		imageCaptchaTrackDto: imageCaptchaTrackDtoData,
	}
	
	return biRequest({ url, method: 'post', data:{
		...submitData
	},isRegister: true });
}


// /**
//  *	@description 验证手机号是否注册
//  * 	@returns
//  */
// export function checkPhoneCount(params) {
// 	const url = proxyHead +  "/Home/GetCounts"
// 	return biRequest({ url, method: 'get', params});
// }


/**
 *	@description 验证手机号是否注册
 * 	@returns
 */
export function checkPhoneCount(params) {
const url = proxyHead + "/api/popularize/public/register/checkIfPhoneNumberRegistered"
	return biRequest({ url, method: 'get', params, isRegister: true });
}

/**
 *	@description 验证用户名是否注册
 * 	@returns
 */
export function checkUsername(params) {
	const url = proxyHead + "Home/GetCountbyUsername"
	return biRequest({ url, method: 'post', params });
}

// /**
//  *	@description 验证用户名是否注册
//  * 	@returns
//  */
// export function checkUsername(params) {
// 	// const url = proxyHead + "Home/GetCountbyUsername"
// 	const url = 'http://www.baiinfo.com/Account/CheckUser'
// 	params['LogName'] =  params['UserName']
// 	params['UserName'] = undefined
// 	return biRequest({ url, method: 'get', params });
// }




// /**
//  *	@description 验证手机验证码
//  * 	@returns
//  */
// export function checkPhoneCode(params) {
// 	const url = proxyHead +  "/Home/CheckCode"
// 	return biRequest({ url, method: 'get', params});
// }
/**
 * 	
 *	@description 验证手机验证码
		@params data { userType url  phone code }
 * 	@returns
 */
export function checkPhoneCode(data) {
	const url = proxyHead +  "/api/popularize/public/register/register"
	return biRequest({ url, method: 'post', data, isRegister: true });
}

// /**
//  *	@description 用户注册
//  * 	@returns
//  */
// export function userRegister(params) {
// 	let url = proxyHead +  "/Home/InsertUsers"
// 	let paramList = []
// 	for (let key in params) {
// 		if(params[key] !== undefined){
// 			let queryStr = key + '=' + params[key]
// 			paramList.push(queryStr)
// 		}

// 	}
// 	let queryStr = paramList.join('&')
// 	url += '?' + queryStr
// 	return biRequest({ url, method:'post'});
// }

/**
 *	@description 用户注册
 *  @params data { userType  url  phone code }
 * 	@returns
 */
export function userRegister(params) {
	let url = proxyHead + "/api/popularize/public/register/checkIfPhoneNumberRegistered"
	return biRequest({ url, method: 'post', params, isRegister: true });
}


// 父级产业
export function getFatherIndustry(params) {
	const url = proxyHead + "/Home/GetAllRegisterParent"
	return biRequest({ url, method: 'get', params });
}


// 子级产业
export function getChildIndustry(params) {
	const url = proxyHead + "/Home/GetChildCategory"
	return biRequest({ url, method: 'get', params });
}

// 登录
// 获取图形验证码
export function getCaptcha() {
  return biRequest({
		url: '/api/popularize/public/register/getslideCaptcha',
    method: 'get',
		isRegister: true 
  })
}
